import { render, staticRenderFns } from "./IntegralCourseItem.vue?vue&type=template&id=61e0c03c&scoped=true&"
import script from "./IntegralCourseItem.vue?vue&type=script&lang=js&"
export * from "./IntegralCourseItem.vue?vue&type=script&lang=js&"
import style0 from "./IntegralCourseItem.vue?vue&type=style&index=0&id=61e0c03c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e0c03c",
  null
  
)

export default component.exports